import {
  blueDrug,
  blueStat,
  greenStat,
  greenWallet,
  lightGreenStat,
  orangeDrug,
  purpleStat,
  redDrug,
} from "@/common/components/icons/svg-icons";

export const pharmacyHeadFinancialCards = [
  {
    id: 1,
    name: "Total Stock",
    value: 20000,
    icon: greenWallet,
    color: "#43A047",
  },
  {
    id: 2,
    name: "Low Stock Drug",
    value: 3,
    icon: orangeDrug,
    color: "#FF9800",
  },
  {
    id: 3,
    name: "Total Drug",
    value: 10,
    icon: blueDrug,
    color: "#2196F3",
  },
  {
    id: 4,
    name: "Expired Drug",
    value: 3,
    icon: redDrug,
    color: "#F44336",
  },
];

export const salesStatisticCards = [
  {
    id: 1,
    name: "Total Stock Value",
    value: 20000,
    icon: purpleStat,
    color: "#28105B",
  },
  {
    id: 2,
    name: "Revenue Generated",
    value: 3,
    icon: blueStat,
    color: "#13A7F6",
  },
  {
    id: 3,
    name: "Fund Allocated",
    value: 10,
    icon: lightGreenStat,
    color: "#4EE437",
  },
  {
    id: 4,
    name: "Current DRF Balance",
    value: 3,
    icon: greenStat,
    color: "#0B7F68",
  },
];

export const newFundRequestForm = [
  {
    inputType: "label",
    label: "Requesting Officer Details",
  },
  {
    inputType: "text",
    name: "firstName",
    prompt: "First Name",
    rules: { required: true },
    placeholder: "Enter First Name",
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "lastname",
    prompt: " Last Name",
    placeholder: "Enter Last Name",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "text",
    name: "email",
    prompt: "Email",
    placeholder: "Enter Email Address",
    rules: { required: true },
    isFullWidth: false,
    required: true,
  },
  {
    inputType: "text",
    name: "number",
    prompt: "Phone Number",
    placeholder: "Enter Phone Number",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "label",
    label: "Request Information",
  },
  {
    inputType: "text",
    name: "request_amount",
    prompt: "Request Amount",
    placeholder: "120,000",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "date",
    name: "request_date",
    prompt: "Request date",
    required: true,
    isFullWidth: false,
  },
  {
    inputType: "textarea",
    name: "purpose",
    prompt: "Purpose of request",
    placeholder: "make it worth it",
    required: true,
    isFullWidth: true,
  },
];

export const fundAllocationRequestTableHeaders = [
  "Request Date",
  "Submitted By",
  "Amount Requested",
  "Status",
];

export const fundAllocationRequestTableKeys = [
  "request_date",
  "submitted_by",
  "amount_requested",
  "status",
];

export const getFundAllocationRequestTableData = (data: any) => [
  {
    id: "1",
    request_date: { value: "2025-07-01", type: "string" },
    submitted_by: { value: "Jane Doe", type: "string" },
    amount_requested: { value: "1200", type: "string" },
    status: { value: "accepted", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
    data: data, // to be remove during integration
  },
  {
    id: "2",
    request_date: { value: "2025-06-28", type: "string" },
    submitted_by: { value: "John Smith", type: "string" },
    amount_requested: { value: "450", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "3",
    request_date: { value: "2025-06-25", type: "string" },
    submitted_by: { value: "Amaka Okafor", type: "string" },
    amount_requested: { value: "870", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "4",
    request_date: { value: "2025-06-20", type: "string" },
    submitted_by: { value: "Chinedu Eze", type: "string" },
    amount_requested: { value: "1500", type: "string" },
    status: { value: "accepted", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "5",
    request_date: { value: "2025-06-18", type: "string" },
    submitted_by: { value: "Fatima Bello", type: "string" },
    amount_requested: { value: "675", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "6",
    request_date: { value: "2025-06-15", type: "string" },
    submitted_by: { value: "Samuel Johnson", type: "string" },
    amount_requested: { value: "920", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "7",
    request_date: { value: "2025-06-12", type: "string" },
    submitted_by: { value: "Ngozi Nwosu", type: "string" },
    amount_requested: { value: "300", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "8",
    request_date: { value: "2025-06-10", type: "string" },
    submitted_by: { value: "Tunde Bakare", type: "string" },
    amount_requested: { value: "1100", type: "string" },
    status: { value: "accepted", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "9",
    request_date: { value: "2025-06-07", type: "string" },
    submitted_by: { value: "Aisha Garba", type: "string" },
    amount_requested: { value: "760", type: "string" },
    status: { value: "pending", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
  {
    id: "10",
    request_date: { value: "2025-06-05", type: "string" },
    submitted_by: { value: "Babatunde Salami", type: "string" },
    amount_requested: { value: "1340", type: "string" },
    status: { value: "rejected", type: "string" },
    justification: {
      value:
        "The requested funds are intended for the immediate replenishment of essential medicines that are currently low in stock, particularly antimalarials and antibiotics, which are critical for addressing the ongoing spike in outpatient cases related to seasonal malaria and bacterial infections. Based on the April consumption data and anticipated patient load, the current inventory will not meet demand for the next 3 weeks. This allocation will ensure uninterrupted service delivery, prevent stockouts, and maintain adherence to the DRF policy on continuous availability of life-saving medications.",
      type: "string",
    },
  },
];

export const salesTableHeaders = [
  "Month",
  "Sales revenue",
  "Restocking Cost",
  "Net Balance",
];

export const salesTableKeys = [
  "month",
  "sales_revenue",
  "restocking_cost",
  "net_balance",
];

export const getSalesTableData = (data: any) => [
  {
    id: "1",
    month: { value: "January", type: "string" },
    sales_revenue: { value: "1000000", type: "string" },
    restocking_cost: { value: "600000", type: "string" },
    net_balance: { value: "400000", type: "string" },
    data: data, // to be remove during integration
  },
  {
    id: "2",
    month: { value: "February", type: "string" },
    sales_revenue: { value: "850000", type: "string" },
    restocking_cost: { value: "500000", type: "string" },
    net_balance: { value: "350000", type: "string" },
  },
  {
    id: "3",
    month: { value: "March", type: "string" },
    sales_revenue: { value: "920000", type: "string" },
    restocking_cost: { value: "550000", type: "string" },
    net_balance: { value: "370000", type: "string" },
  },
  {
    id: "4",
    month: { value: "April", type: "string" },
    sales_revenue: { value: "1100000", type: "string" },
    restocking_cost: { value: "620000", type: "string" },
    net_balance: { value: "480000", type: "string" },
  },
  {
    id: "5",
    month: { value: "May", type: "string" },
    sales_revenue: { value: "950000", type: "string" },
    restocking_cost: { value: "570000", type: "string" },
    net_balance: { value: "380000", type: "string" },
  },
  {
    id: "6",
    month: { value: "June", type: "string" },
    sales_revenue: { value: "1020000", type: "string" },
    restocking_cost: { value: "630000", type: "string" },
    net_balance: { value: "390000", type: "string" },
  },
  {
    id: "7",
    month: { value: "July", type: "string" },
    sales_revenue: { value: "1150000", type: "string" },
    restocking_cost: { value: "670000", type: "string" },
    net_balance: { value: "480000", type: "string" },
  },
  {
    id: "8",
    month: { value: "August", type: "string" },
    sales_revenue: { value: "1080000", type: "string" },
    restocking_cost: { value: "620000", type: "string" },
    net_balance: { value: "460000", type: "string" },
  },
  {
    id: "9",
    month: { value: "September", type: "string" },
    sales_revenue: { value: "990000", type: "string" },
    restocking_cost: { value: "590000", type: "string" },
    net_balance: { value: "400000", type: "string" },
  },
  {
    id: "10",
    month: { value: "October", type: "string" },
    sales_revenue: { value: "1040000", type: "string" },
    restocking_cost: { value: "640000", type: "string" },
    net_balance: { value: "400000", type: "string" },
  },
];
